// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IAddCallbackRequest,
  TAddCallbackModel,
  IMappers,
  TAddCallbackResponse,
  IAddCallbackResponse,
  IAddCallbackResponseError,
} from './types';

export const defaultConfig: TAddCallbackModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-calltracking',
  pathApi: '/v1/add-callback/',
  requestType: 'json',
} as TAddCallbackModel;

export function createAddCallbackModel(parameters: IAddCallbackRequest): TAddCallbackModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddCallbackOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IAddCallbackRequest;
}

export async function fetchAddCallback<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddCallbackOptions<TResponse200, TResponse400>): Promise<TAddCallbackResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createAddCallbackModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddCallbackResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IAddCallbackResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TAddCallbackResponse;
}
